import { useEffect, useState } from "react";
import { SelectFields } from "../../components/select/SelectFields";
import FormController from "../../components/fields/FormController";
import Button from "../../components/button/Button";
import { MagnifyingGlassIcon, ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { useForm } from "react-hook-form";
import { CheckBoxGroup, CheckBoxItem } from "../../components/checkBox/CheckBoxGroup";
import { CheckBox } from "../../components/checkBox/CheckBox";
import { PointHistoryData, SearchPoint, PointListSearchDefault, PointCategory, PointType } from "../../model/PointData";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";

type Props = {
  pointList: PointHistoryData[];
  setSearchUserPointHistoryList: Function;
  setSearchUserPointHistoryFlg: Function;
  ptNameList: any[];
  pointCategoryList: PointCategory[];
  pointTypeList: PointType[];
};

export const UserPointHistorySearch = ({
  pointList,
  setSearchUserPointHistoryList,
  setSearchUserPointHistoryFlg,
  ptNameList,
  pointCategoryList,
  pointTypeList,
}: Props) => {
  //ポイントカテゴリ未選択時のid
  const unselected = -1;

  const dispatch = useDispatch();
  const [searchItem, setSearchItem] = useState<SearchPoint>(PointListSearchDefault);
  const [searchFlg, setSearchFlg] = useState(false);
  const { control } = useForm<PointHistoryData & {}>({});
  const [selectTranType, setSelectTranType] = useState<CheckBoxItem[]>([]);
  const [checkedDate, setCheckedDate] = useState<string>("");
  const [ptNamesList, setPtNamesList] = useState([]);
  const [ptCategoryList, setCategoriesList] = useState([]);
  const [ptTypesList, setTypesList] = useState([]);

  // アイコン設定
  const searchIcon = { icon: MagnifyingGlassIcon };
  const upIcon = { icon: ChevronUpIcon };
  const downIcon = { icon: ChevronDownIcon };
  //初期表示
  useEffect(() => {
    const f = async () => {
      try {
        //取引種別
        let selectTranType = transactionTypeList ? await Promise.all(transactionTypeList.map((item): CheckBoxItem => {
          return {
            id: item.id,
            title: item.title,
            value: false,
          }
        })) : [];
        setSelectTranType(selectTranType);

        //ポイントカテゴリ
        let ptCategoriesList: any = [
          { id: unselected, name: "" },
        ];
        pointCategoryList.map((ptCategory: any) => {
          if (ptCategory.categoryId != undefined) {
            ptCategoriesList.push({ id: ptCategory.categoryId, name: ptCategory.categoryName, sortKey: ptCategory.sortKey });
          }
        })
        setCategoriesList(ptCategoriesList);

        //ポイントタイプ
        let ptTypesList: any = [
          { name: "" },
        ];
        pointTypeList.map((ptType: any) => {
          if (ptType.categoryId != undefined) {
            ptTypesList.push({ id: ptType.typeId, name: ptType.typeName, sortKey: ptType.sortKey });
          }
        })
        setTypesList(ptTypesList);

        //ポイント名
        let ptNamesList: any = [
          { name: "" },
        ];
        ptNameList.map((ptName: string) => {
          if (ptName != "undefined") {
            ptNamesList.push({ name: ptName });
          }
        })
        setPtNamesList(ptNamesList);
      } catch (err: any) {
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
    }
    f();
  }, []);

  // 検索画面の表示・非表示の切り替え
  const handleClick = (e: any) => {
    e.preventDefault();
    setSearchFlg(searchFlg ? false : true);
  };

  //取引種別チェックボックス
  const transactionTypeList = [
    { id: "grant", title: "付与", value: false, },
    { id: "use", title: "利用", value: false, },
    { id: "adjustment", title: "調整", value: false, },
    { id: "revocation", title: "失効", value: false, },
  ]

  //チェックボックス（日付フォーム）の値を管理
  const changedDateCheckBox = (e: any, value: string) => {
    setSearchItem(
      {
        ...searchItem,
        expirationDateStart: "", expirationDateEnd: "", occurrenceDateStart: "", occurrenceDateEnd: "",
      }
    );
    setCheckedDate(value);
  }

  // 検索を実行
  const onClickSearch = async () => {
    let newList = pointList;
    //取引種別
    const targetTranList = selectTranType.filter((tranType) => tranType.value === true).map((tranType) => tranType.title);
    if (targetTranList.length > 0) {
      let resultList: PointHistoryData[] = [];
      let targetList: PointHistoryData[] = [];
      for (let i = 0; i < targetTranList.length; i++) {
        targetList = newList.filter((userPointNewList: { tranType?: string; }) =>
          userPointNewList.tranType == targetTranList[i]
        );
        resultList = resultList.concat(targetList);
      }
      newList = resultList;
    }
    //ポイントカテゴリ
    if (searchItem.ptCategoryId != undefined && searchItem.ptCategoryId != unselected) {
      newList = newList.filter((userPointNewList: { ptCategoryId?: number; }) =>
        userPointNewList.ptCategoryId === searchItem.ptCategoryId
      );
    }
    //ポイントタイプ
    if (searchItem.ptTypeId != "") {
      if (searchItem.ptTypeId != undefined) {
        newList = newList.filter((userPointNewList: { ptTypeId?: string; }) =>
          userPointNewList.ptTypeId == searchItem.ptTypeId
        );
      }
    }
    //ポイント名
    if (searchItem.ptName != "") {
      newList = newList.filter((userPointNewList: { ptName?: string; }) =>
        userPointNewList.ptName?.slice(0, searchItem.ptName.length) === searchItem.ptName
      );
    }
    //有効期限
    if (searchItem.expirationDateStart != "" && checkedDate == "expirationDate") {
      const date = new Date(searchItem.expirationDateStart + "T00:00:00.000+09:00");
      newList = newList.filter((userPointNewList: { expirationDate?: Date; }) =>
        userPointNewList.expirationDate ? new Date(userPointNewList.expirationDate) >= date : ""
      );
    }
    if (searchItem.expirationDateEnd != "" && checkedDate == "expirationDate") {
      const date = new Date(searchItem.expirationDateEnd + "T23:59:59.000+09:00");
      newList = newList.filter((userPointNewList: { expirationDate?: Date; }) =>
        userPointNewList.expirationDate ? new Date(userPointNewList.expirationDate) <= date : ""
      );
    }
    //ポイント発生日
    if (searchItem.occurrenceDateStart != "" && checkedDate == "occurrenceDate") {
      const date = new Date(searchItem.occurrenceDateStart + "T00:00:00.000+09:00");
      newList = newList.filter((userPointNewList: { occurrenceDate?: Date; }) =>
        userPointNewList.occurrenceDate ? new Date(userPointNewList.occurrenceDate) >= date : ""
      );
    }
    if (searchItem.occurrenceDateEnd != "" && checkedDate == "occurrenceDate") {
      const date = new Date(searchItem.occurrenceDateEnd + "T23:59:59.000+09:00");
      newList = newList.filter((userPointNewList: { occurrenceDate?: Date; }) =>
        userPointNewList.occurrenceDate ? new Date(userPointNewList.occurrenceDate) <= date : ""
      );
    }
    setSearchUserPointHistoryList(newList);
    setSearchUserPointHistoryFlg(true);
  };

  return (
    <div className="flex h-full">
      <div className="inline-block min-w-full p-1 align-middle">
        <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
          <table className="min-w-full table-fixed divide-y">
            <div className="sm:items-center p-2">
              <div className="flex justify-between cursor-pointer" onClick={(e) => handleClick(e)}>
                <h2 className=" flex font-semibold text-gray-900 items-center">
                  <searchIcon.icon
                    className={"flex-shrink-0 h-5 w-5"}
                    aria-hidden="true"
                  />
                  検索
                </h2>
                {searchFlg ? (
                  <>
                    <upIcon.icon
                      className={"flex-shrink-0 h-5 w-5"}
                      aria-hidden="true"
                    />
                  </>
                ) : (
                  <>
                    <downIcon.icon
                      className={"flex-shrink-0 h-5 w-5"}
                      aria-hidden="true"
                    />
                  </>
                )}
              </div>
              {searchFlg ? (
                <>
                  <h3 className="text-sm text-gray-500 my-1 mt-4">&nbsp;複数項目を入力した場合はAND検索となります</h3>
                  <div className="flex justify-between">
                    <div className="w-3/10 p-2">
                      <div className="flex flex-col gap-1">
                        <div className="ml-3 flex sm:items-center flex-wrap">
                          <h3 className="text-sm text-gray-900">取引種別　　　　</h3>
                          <div>
                            <CheckBoxGroup
                              children={undefined}
                              setState={setSelectTranType}
                              name={"tranType"}
                              checkBoxItem={selectTranType}
                              vertical={true}
                              boxClassName={"mr-1"}
                              titleClassName={"mr-1 text-gray-900"}
                              className={"flex-nowrap"}
                            />
                          </div>
                        </div>
                        <div className="ml-3 flex sm:items-center flex-1 flex-wrap">
                          <h3 className="text-sm text-gray-900">カテゴリ　</h3>&nbsp;
                          <div className="w-1/10">
                            <SelectFields
                              id="ptCategory"
                              color="indigo"
                              value={searchItem.ptCategoryId}
                              className={"h-10 w-60"}
                              selectItems={ptCategoryList}
                              onChange={(e: any) => setSearchItem({ ...searchItem, ptCategoryId: Number(e.target.value) })}
                            />
                          </div>
                        </div>
                        <div className="ml-3 flex sm:items-center flex-1 flex-wrap">
                          <h3 className="text-sm text-gray-900">タイプ　　</h3>&nbsp;
                          <div className="w-1/10">
                            <SelectFields
                              id="pointType"
                              color="indigo"
                              value={searchItem.ptTypeId}
                              className={"h-10 w-60"}
                              selectItems={ptTypesList}
                              onChange={(e: any) => setSearchItem({ ...searchItem, ptTypeId: e.target.value })}
                            />
                          </div>
                        </div>
                        <div className="ml-3 flex sm:items-center flex-1 flex-wrap">
                          <h3 className="text-sm text-gray-900">ポイント名</h3>&nbsp;
                          <div className="w-1/10">
                            <SelectFields
                              id="ptName"
                              color="indigo"
                              value={searchItem.ptName}
                              className={"h-10 w-60"}
                              selectItems={ptNamesList}
                              onChange={(e: any) => setSearchItem({ ...searchItem, ptName: e.target.value })}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-3/10 p-2">
                      <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg max-w-lg h-fit">
                        <div className="p-2 flex flex-col gap-1">
                          <h3 className="text-sm text-gray-500 mb-3 ml-2">いずれか１つの項目を選択してください</h3>
                          <div className="flex sm:items-center ml-3 flex-wrap">
                            <h3 className="text-sm text-gray-900">有効期限　　　</h3>&nbsp;
                            <div className="flex items-center">
                              <CheckBox
                                id="expirationDate"
                                value={checkedDate == "expirationDate" ? true : false}
                                onChange={(e: any) => changedDateCheckBox(e, checkedDate == "expirationDate" ? "" : "expirationDate")}
                              />
                              <FormController
                                control={control}
                                value={searchItem.expirationDateStart}
                                className={"mr-1 h-10"}
                                inputClassName={`${checkedDate == "expirationDate" ? "" : "bg-gray-300"} h-8`}
                                name={"expirationDate_s"}
                                label={""}
                                onChange={(e: any) => setSearchItem({ ...searchItem, expirationDateStart: e.target.value })}
                                type={"date"}
                                disabled={checkedDate == "expirationDate" ? false : true}
                              />
                              ～
                              <FormController
                                control={control}
                                value={searchItem.expirationDateEnd}
                                className={"ml-1 h-10"}
                                inputClassName={`${checkedDate == "expirationDate" ? "" : "bg-gray-300"} h-8`}
                                name={"expirationDate_e"}
                                label={""}
                                onChange={(e: any) => setSearchItem({ ...searchItem, expirationDateEnd: e.target.value })}
                                type={"date"}
                                disabled={checkedDate == "expirationDate" ? false : true}
                              />
                            </div>
                          </div>
                          <div className="ml-3 flex sm:items-center justify-start flex-wrap">
                            <h3 className="text-sm text-gray-900">ポイント発生日</h3>&nbsp;
                            <div className="flex items-center">
                              <CheckBox
                                id="occurrenceDate"
                                value={checkedDate == "occurrenceDate" ? true : false}
                                onChange={(e: any) => changedDateCheckBox(e, checkedDate == "occurrenceDate" ? "" : "occurrenceDate")}
                              />
                              <FormController
                                control={control}
                                value={searchItem.occurrenceDateStart}
                                className={"mr-1 h-10"}
                                inputClassName={`${checkedDate == "occurrenceDate" ? "" : "bg-gray-300"} h-8`}
                                name={"occurrenceDate_s"}
                                label={""}
                                onChange={(e: any) => setSearchItem({ ...searchItem, occurrenceDateStart: e.target.value })}
                                type={"date"}
                                disabled={checkedDate == "occurrenceDate" ? false : true}
                              />
                              ～
                              <FormController
                                control={control}
                                value={searchItem.occurrenceDateEnd}
                                className={"ml-1 h-10"}
                                inputClassName={`${checkedDate == "occurrenceDate" ? "" : "bg-gray-300"} h-8`}
                                name={"occurrenceDate_e"}
                                label={""}
                                onChange={(e: any) => setSearchItem({ ...searchItem, occurrenceDateEnd: e.target.value })}
                                type={"date"}
                                disabled={checkedDate == "occurrenceDate" ? false : true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-3/10 flex flex-col gap-1">
                      <div className={`flex flex-grow items-end justify-end mt-2 mb-3 mr-2`}>
                        <Button
                          className={"h-10 w-32 text-sm sm:items-center"}
                          onClick={() => onClickSearch()}
                          children={"検索"}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                </>
              )}
            </div>
          </table>
        </div>
      </div>
    </div>
  )
};